<div class="px-6 py-4 font-medium relative min-h-[calc(100vh-4rem)]">
  <p class="text-amazone-green ms-2">Create new NW-Numbers and optionally import DTCs from Excel file</p>
  <div class="relative overflow-x-auto shadow-md sm:rounded-lg max-h-screen-200 overflow-y-auto px-4">
    <form>
      <div class="grid gap-6 mt-6 md:grid-cols-2 border-b border-gray-900/10 pb-6">
        <div class="col-span-full">
          <div class="grid gap-6 mb-6 md:grid-cols-3">
            <div>
              <label for="nwNumber" class="block mb-2 text-sm font-medium text-gray-800">NW-Number</label>
              <input
                type="text"
                id="priority"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-amazone-orange focus:border-amazone-orange block w-full p-2.5"
                [placeholder]="nwNumberPlaceholder"
                [formControl]="nwNumber"
              />
            </div>
            <div>
              <label for="majorVersion" class="block mb-2 text-sm font-medium text-gray-800">Major Version</label>
              <input
                type="text"
                id="priority"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-amazone-orange focus:border-amazone-orange block w-full p-2.5"
                [placeholder]="majorVersionPlaceholder"
                [formControl]="majorVersion"
              />
            </div>
            <div>
              <label for="group" class="block mb-2 text-sm font-medium text-gray-800"
                >Excel File (if omitted, an empty SwPartNumber will be created)</label
              >
              <app-upload-file
                [labelIsHidden]="true"
                [showCloseButton]="false"
                [accept]="'.xlsx'"
                [multiple]="false"
                (fileSelected)="onExcelSelected($event)"
              ></app-upload-file>
            </div>
          </div>
        </div>
        <div class="inline-flex justify-center gap-x-2 col-span-full">
          <button
            data-tooltip-target="tooltip-import"
            type="button"
            [disabled]="form.invalid"
            (click)="importExcel()"
            class="px-4 py-2 text-sm font-medium border rounded-lg focus:z-10 focus:ring-2 bg-amazone-gray text-white hover:bg-gray-800 focus:ring-amazone-orange"
            [ngClass]="{
              'cursor-not-allowed': form.invalid,
              'opacity-25': form.invalid,
            }"
            appAgentAction
            agent="dtc-import-submit"
            businessObject="dtc"
            action="import"
          >
            {{ formButtonLable }}
          </button>
          @if (!inputData.nwNumber) {
            <div
              id="tooltip-import"
              role="tooltip"
              class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-xs opacity-0 tooltip dark:bg-gray-700"
            >
              NW-Number is required
              <div class="tooltip-arrow" data-popper-arrow></div>
            </div>
          }
          @if (!inputData.majorVersion) {
            <div
              id="tooltip-import"
              role="tooltip"
              class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-xs opacity-0 tooltip dark:bg-gray-700"
            >
              Major Version is required
              <div class="tooltip-arrow" data-popper-arrow></div>
            </div>
          }
        </div>
      </div>
    </form>
    @if ((importReport?.logItems?.length ?? 0) > 0) {
      <div class="relative overflow-x-auto shadow-md sm:rounded-lg overflow-y-auto">
        <div class="w-full my-4 pe-10">
          <button
            (click)="closeLogs()"
            type="button"
            class="absolute top-0 end-0 mt-2 me-2 font-medium text-gray-400 hover:text-gray-600 cursor-pointer hover:scale-110"
            appAgentAction
            agent="dtc-import-close-logs"
            businessObject="dtc"
            action="close"
          >
            <app-cancel-icon></app-cancel-icon>
          </button>
          <app-translation-import-reporter
            [reports]="importReport?.logItems ?? []"
            [title]="'Import warning and error report'"
          ></app-translation-import-reporter>
        </div>
      </div>
    }
  </div>
</div>
